export default __webpack_public_path__ + "static/media/All_dressed_in_blue.d485cb1f.mp3";